export default __webpack_public_path__ + "static/media/Rollo.4b9f3f03.jpeg";